import { Provider } from "react-redux";
import Header from "./components/Header";
import InputContainer from "./components/InputContainer";
import PreviewContainer from "./components/PreviewContainer";
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <div>
        <Header />
        <InputContainer />
        <PreviewContainer />
      </div>
    </Provider>
  );
}

export default App;
